import type { CSSProperties, JSX } from 'react';
import type { Palette } from '../../../../_theme/palette.js';
import type { SurveyQuestion } from '../../types.js';

interface ConsentFieldProps {
  palette: Palette;
  question: SurveyQuestion;
  value: unknown;
  onChange: (value: boolean) => void;
}

export function ConsentField({ palette, question, value, onChange }: ConsentFieldProps): JSX.Element {
  const checked = value === true;
  const text = question.settings?.consentText?.trim() || 'I agree.';
  return (
    <button type="button" onClick={() => onChange(!checked)} style={buttonStyle(palette, checked)}>
      <CheckboxMark checked={checked} palette={palette} />
      <span style={textStyle(palette)}>{text}</span>
    </button>
  );
}

function CheckboxMark({ checked, palette }: { checked: boolean; palette: Palette }): JSX.Element {
  return (
    <span
      aria-hidden="true"
      style={{
        width: 20,
        height: 20,
        borderRadius: 4,
        border: `2px solid ${checked ? palette.primary : palette.border}`,
        background: checked ? palette.primary : 'transparent',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        transition: 'all 120ms ease',
      }}
    >
      {checked && (
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6L9 17l-5-5" />
        </svg>
      )}
    </span>
  );
}

function buttonStyle(palette: Palette, checked: boolean): CSSProperties {
  return {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    padding: '14px 16px',
    border: `1px solid ${checked ? palette.primary : palette.border}`,
    borderRadius: 10,
    background: palette.card,
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'border-color 120ms ease',
  };
}

function textStyle(palette: Palette): CSSProperties {
  return { fontSize: 14, color: palette.text, lineHeight: 1.5 };
}
